import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.8062 10.4424L12.1393 14.8166C11.7227 15.2072 11.0004 14.9338 11.0004 14.374V11.8744H7.22243C6.85297 11.8744 6.55573 11.5958 6.55573 11.2495V8.74993C6.55573 8.40363 6.85297 8.12503 7.22243 8.12503H11.0004V5.62545C11.0004 5.06825 11.7199 4.79226 12.1393 5.18282L16.8062 9.55709C17.0646 9.80184 17.0646 10.1976 16.8062 10.4424ZM8.3336 14.6864V13.645C8.3336 13.4731 8.18359 13.3325 8.00025 13.3325H5.6668C5.17511 13.3325 4.77787 12.9602 4.77787 12.4993V7.50014C4.77787 7.03928 5.17511 6.66694 5.6668 6.66694H8.00025C8.18359 6.66694 8.3336 6.52634 8.3336 6.3545V5.313C8.3336 5.14116 8.18359 5.00055 8.00025 5.00055H5.6668C4.1945 5.00055 3 6.12016 3 7.50014V12.4993C3 13.8793 4.1945 14.9989 5.6668 14.9989H8.00025C8.18359 14.9989 8.3336 14.8583 8.3336 14.6864Z",
		fill: "#0D2976"
	})
});
export default SvgLogout;
